/* @flow */

import type { KeyValuePair } from '../../../../helpers/jsHelpers/types';
import type { NETGEM_API_URL_LIFECYCLE } from '../../ntgEntitlement/types';
import type { NETGEM_API_V8_METADATA_SCHEDULE_VIDEO_STREAM_ENTITLEMENT_PARAM, StreamType } from './MetadataSchedule';
import type { NETGEM_API_V8_RIGHTS } from './Rights';

import { Drm } from '../../../../helpers/jsHelpers/Drm';
import { HttpMethod } from './HttpMethod';

export const METRICS_NIELSEN = 'Nielsen';
export type METRICS_TYPE = 'Nielsen';

export enum MetricsStreamType {
  Catchup = 'catchup',
  Live = 'live',
}

export enum MetricsProperties {
  Desktop = 'desktop',
  Mobile = 'mobile',
  Stb = 'stb',
  Tablet = 'tablet',
}

export type NIELSEN_METRICS_PARAMS = {
  assetid?: ?string,
  cli_ch?: ?string,
  cli_cn?: ?string,
  cli_md?: ?string,
  islivestn?: ?string,
  length?: ?string,
  nol_p0?: ?string,
  nol_p1?: ?string,
  nol_p2?: ?string,
  nol_p3?: ?string,
  nol_p4?: ?string,
  nol_p5?: ?string,
  nol_p6?: ?string,
  nol_p7?: ?string,
  nol_p8?: ?string,
  nol_p9?: ?string,
  nol_p10?: ?string,
  nol_p11?: ?string,
  nol_p12?: ?string,
  nol_p13?: ?string,
  nol_p14?: ?string,
  nol_p15?: ?string,
  nol_p16?: ?string,
  nol_p17?: ?string,
  nol_p18?: ?string,
  nol_p19?: ?string,
  program?: ?string,
  subbrand?: ?string,
  title?: ?string,
  type?: ?string,
};

export type NIELSEN_METRICS_PROPERTIES = {
  channel: string,
  device: MetricsProperties,
  params: NIELSEN_METRICS_PARAMS,
  serial: string,
  type: MetricsStreamType,
  vcid: string,
};

type NETGEM_API_CHANNEL_INFO_METRICS = {
  type: METRICS_TYPE,
  properties: Array<NIELSEN_METRICS_PROPERTIES>,
};

type NETGEM_API_CHANNEL_DRM_TYPE = {
  ntgEntitlement: NETGEM_API_V8_METADATA_SCHEDULE_VIDEO_STREAM_ENTITLEMENT_PARAM,
  type: Drm,
};

export type NETGEM_API_CHANNEL_PLAYBACK_PARAMS_ARG_TYPE = {
  drms: Array<NETGEM_API_CHANNEL_DRM_TYPE>,
  path: string,
  type: StreamType,
};

type NETGEM_API_CHANNEL_PLAYBACK_PARAMS_TYPE = {
  name: string,
  value: {
    args: Array<NETGEM_API_CHANNEL_PLAYBACK_PARAMS_ARG_TYPE>,
    op: string,
  },
};

type NETGEM_API_CHANNEL_PLAYBACK_TYPE = {
  player: string,
  start: {
    method: HttpMethod,
    params: Array<NETGEM_API_CHANNEL_PLAYBACK_PARAMS_TYPE>,
    redirect?: boolean,
    uri: string,
  },
};

type NETGEM_API_CHANNEL_URL_CONTENT_TYPE = {
  playback?: NETGEM_API_CHANNEL_PLAYBACK_TYPE,
  playbacks?: Array<NETGEM_API_CHANNEL_PLAYBACK_TYPE>,
};

export type NETGEM_API_CHANNEL_INFO = {
  baseline?: string,
  channelGrId?: string,
  channelId: string,
  hasCatchup?: boolean,
  hasKeepFromReplay?: boolean,
  images?: Array<{ id: string }>,
  isRecordable?: boolean,
  languages?: Array<string>,
  metrics?: Array<NETGEM_API_CHANNEL_INFO_METRICS>,
  name?: string,
  owner?: string,
  rights?: NETGEM_API_V8_RIGHTS,
  tags?: Array<string>,
  urlContentType?: NETGEM_API_CHANNEL_URL_CONTENT_TYPE,
};

export type NETGEM_API_CONSOLIDATED_CHANNEL = {
  hasCatchup?: boolean,
  hasKeepFromReplay?: boolean,
  hasStartover?: boolean,
  hasTimeshift?: boolean,
  imageId: ?string,
  isRecordable?: boolean,
};

export type NETGEM_API_CHANNEL = {
  adult: boolean,
  altimg: string,
  amsnumber: string,
  consolidated?: NETGEM_API_CONSOLIDATED_CHANNEL,
  data: {
    npvr: {
      hasCatchup: string,
      hasKeepFromReplay: string,
      hasStartover: string,
      isRecordable: string,
    },
    stream: {
      debug: string,
      drmType?: Drm,
      isSeekable: string,
      laUrl: string,
      msdrmCustomData: string,
      notrickmode: string,
      service: string,
      type?: StreamType,
    },
    urlLifecycle?: NETGEM_API_URL_LIFECYCLE,
  },
  epgid: string,
  id: string,
  img: string,
  info?: NETGEM_API_CHANNEL_INFO,
  isFastChannel: boolean,
  isHidden: boolean,
  name: string,
  number: number,
  template: string,
  url: string,
};

export type ChannelMap = KeyValuePair<NETGEM_API_CHANNEL>;
